document.addEventListener("DOMContentLoaded", function () {
  const popup = document.getElementById("video-popup");
  const closeBtn = document.getElementById("close-video-popup");
  const videoIframe = document.getElementById("youtube-video");

  let isDragging = false;
  let offsetX = 0;
  let offsetY = 0;

  // Ouverture de la popup
  if(document.getElementById("open-video-popup")) {
    document.getElementById("open-video-popup").addEventListener("click", () => {
       videoIframe.src = "";
      videoIframe.src = "https://www.youtube.com/embed/UrKTRCVx5QE?si=BCKOpIY_LxQupY8r";
      popup.classList.remove("hidden12");
    });
  }else if (document.getElementById("open-video-popup_Action")){
    document.getElementById("open-video-popup_Action").addEventListener("click", () => {
       videoIframe.src = "";
      videoIframe.src = "https://www.youtube.com/embed/REw9UzHve0U?si=13bVnDUefTNlY_Ro";
      popup.classList.remove("hidden12");
    });
  }else if (document.getElementById("open-video-popup_Urban")){
    document.getElementById("open-video-popup_Urban").addEventListener("click", () => {
       videoIframe.src = "";
      videoIframe.src = "https://www.youtube.com/embed/RMDy73WLfg0?si=8XM2KnEIfr3z9VC4";
      popup.classList.remove("hidden12");
    });
  }
  
 
  // Fermeture de la popup
  closeBtn.addEventListener("click", () => {
    videoIframe.src = "";
    popup.classList.add("hidden12");
  });

  // Début du drag
  popup.addEventListener("mousedown", (e) => {
    isDragging = true;
    offsetX = e.clientX - popup.offsetLeft;
    offsetY = e.clientY - popup.offsetTop;
    popup.style.cursor = "grabbing";
  });

  // Fin du drag
  document.addEventListener("mouseup", () => {
    isDragging = false;
    popup.style.cursor = "move";
  });

  // Mouvement du drag
  document.addEventListener("mousemove", (e) => {
    if (!isDragging) return;
    const x = e.clientX - offsetX;
    const y = e.clientY - offsetY;

    popup.style.left = `${x}px`;
    popup.style.top = `${y}px`;
  });
});
